import { FC, useState, useEffect } from 'react';
import { Box, Typography, Stack, Fade, Button } from '@mui/material';
import { keyframes } from '@emotion/react';


const breathe = keyframes`
  0% { transform: scale(0.5); }
  50% { transform: scale(1); }
  100% { transform: scale(0.5); }
`;

interface Props {
  title: string;
  subtitle: string;
  duration: number;
  onComplete: () => void;
}

export const GroundingExercise: FC<Props> = ({ title, subtitle, duration, onComplete }) => {
  const [showReveal, setShowReveal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowReveal(true);
    }, Math.min(duration * 1000, 10000));

    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Stack alignItems="center" justifyContent="center" spacing={4} sx={{ minHeight: '80vh' }}>
      <Typography variant="h4" textAlign="center" fontSize={20}>
        {title}
      </Typography>
      <Box
        sx={{
          width: 128,
          height: 128,
          borderRadius: '50%',
          border: '2px solid',
          borderColor: '#ef962a66',
          animation: `${breathe} 8s ease-in-out infinite`,
        }}
      />
      <Typography px={6} whiteSpace="pre-wrap" variant="body1" textAlign="center" color="text.secondary">
        {subtitle}
      </Typography>
      <Fade in={showReveal}>
        <Box>
          <Button variant="contained" size="large" onClick={onComplete}>
            Reveal My Activation
          </Button>
        </Box>
      </Fade>
    </Stack>
  );
};
